module.exports = __webpack_public_path__ + "media/images/nini_escada-b3c1752ba2ccd277181430ab2fad393b.png";